import { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

const useNoOptionsMessage = () => useCallback(({ inputValue }: { inputValue: string }) => {
  if (inputValue) {
    return <FormattedMessage defaultMessage="No cities" />;
  }
  return <FormattedMessage defaultMessage="Start typing" />;
}, []);

export { useNoOptionsMessage };
